import {
	ComponentFactoryResolver,
	Injectable,
	ViewContainerRef,
} from '@angular/core';

@Injectable()
export class FnComponentRenderService {
	private componentMap:any= {};
	private resolver: ComponentFactoryResolver;
	renderComponent(componentId: string, container: ViewContainerRef) {
		if (this.componentMap) {
			const component = this.componentMap[componentId];
			if (component) {
				const componentFactory = this.resolver.resolveComponentFactory(
					component
				);
				const viewContainerRef = container;
				viewContainerRef.clear();

				return viewContainerRef.createComponent<any>(componentFactory);
			}else{
                return null;
            }
		}else{
            return null;
        }
	}
	setComponents(componets: any) {
		this.componentMap = componets;
	}
	setFactoryResolver(resolver: ComponentFactoryResolver) {
		this.resolver = resolver;
	}
}
